import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom"; 
// NOTE: We are removing the external import to include the logic here for demonstration
// import useScrollReveal from "../hooks/useScrollReveal"; 

// Import CSS
import "../../styles/module/header.css"; 

import logo from "../../assets/images/img/favicon_logo.png";
import fb_white from "../../assets/images/navbar/facebook-white.svg";
import insta_white from "../../assets/images/navbar/instagram-white.svg";
import linkedin_white from "../../assets/images/navbar/linkedin-white.svg";

// -------------------------------------------------------------------
// MOCK useScrollReveal HOOK (IMPLEMENTED INLINE FOR TESTING)
// This logic MUST be running for the 'sticky' class to be applied.
// In your production code, this should be in ../hooks/useScrollReveal.js
const useScrollReveal = (threshold = 100) => {
    const headerRef = useRef(null);

    useEffect(() => {
        const currentRef = headerRef.current;
        if (!currentRef) return;

        const handleScroll = () => {
            // Check if scrolled past the threshold (100px)
            if (window.scrollY > threshold) {
                currentRef.classList.add('sticky');
            } else {
                currentRef.classList.remove('sticky');
            }
        };

        // Add scroll listener and check initial position
        window.addEventListener('scroll', handleScroll);
        handleScroll();

        // Cleanup
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold]);

    return headerRef;
};
// -------------------------------------------------------------------

// Menu Items Configuration
const menuItems = [
    { name: "About Us", path: "/about-us" },
    { name: "Our Services", path: "/services" },
    { name: "Utilities", path: "/utilities" },
    { name: "Contact", path: "/contact" },
];

// Social Links Configuration
const socialLinks = [
    { href: "https://www.facebook.com/genvixtech", icon: fb_white, alt: "facebook" },
    { href: "https://www.instagram.com/genvixtech", icon: insta_white, alt: "instagram" },
    { href: "https://www.linkedin.com/company/genvixtech", icon: linkedin_white, alt: "linkedin" },
];

const Header = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    // 1. Pass a threshold (e.g., 100) to the hook to determine when 'sticky' should be added
    const headerRef = useScrollReveal(100); 

    const closeMenu = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            closeMenu();
        }
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps


    return (
        // The 'sticky' class will be added to this element by the useScrollReveal hook when scrolling
        <header className="header-main-wrapper" ref={headerRef}>
            <div className="container header"> 
                
                <div className="header-content-row">
                    
                    {/* Logo Link */}
                    <a href="/" className="logo">
                        <img src={logo} alt="Company Logo" />
                    </a>

                    {/* Desktop/Tablet Navigation */}
                    <nav className="nav-inline">
                        <ul className="menu">
                            {menuItems.map((item) => (
                                <li
                                    key={item.path}
                                    className={location.pathname === item.path ? "current-menu-item" : ""}
                                >
                                    <a href={item.path}>{item.name}</a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Mobile Toggle (Hamburger Icon) */}
                    <div 
                        className={`menu-toggle ${open ? 'menu-toggle-hidden-on-open' : ''}`} 
                        onClick={() => setOpen(true)}
                    >
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                    </div>
                </div>
            </div>


            {/* Mobile Overlay Menu */}
            <div className={`mobile-overlay ${open ? "open" : ""}`}>
                <div className="overlay-content">
                    <div className="overlay-header">
                        <div className="overlay-logo">
                            {/* LOGO REMOVED */}
                        </div>
                        {/* Close button */}
                        <div className="close-btn" onClick={closeMenu}>&times;</div>
                    </div>
                    
                    <nav className="nav-mobile">
                        <ul className="menu">
                            {menuItems.map((item) => (
                                <li
                                    key={item.path}
                                    className={location.pathname === item.path ? "current-menu-item" : ""}
                                >
                                    <a href={item.path} onClick={closeMenu}>
                                        {item.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Mobile Social Icons */}
                    <div className="icons-set-drawer">
                        {socialLinks.map((link) => (
                            <a
                                key={link.alt}
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                onClick={closeMenu} 
                            >
                                <img src={link.icon} alt={link.alt} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;